import { render, staticRenderFns } from "./PurchaseDemand.vue?vue&type=template&id=6ab6fbe0&scoped=true"
import script from "./PurchaseDemand.vue?vue&type=script&lang=js"
export * from "./PurchaseDemand.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDemand.vue?vue&type=style&index=0&id=6ab6fbe0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab6fbe0",
  null
  
)

export default component.exports